const topics = [
  { name: '#每日爆料', count: '2,847万', hot: true },
  { name: '#娱乐圈大瓜', count: '1,923万', hot: true },
  { name: '#科技圈爆料', count: '1,456万', hot: false },
  { name: '#体育转会', count: '1,289万', hot: true },
  { name: '#社会热点', count: '1,167万', hot: false },
  { name: '#财经内幕', count: '983万', hot: false },
  { name: '#国际动态', count: '876万', hot: false },
  { name: '#网络热议', count: '754万', hot: true },
  { name: '#独家爆料', count: '632万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最受关注的爆料话题标签，点击探索更多内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#"
              className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer no-underline"
            >
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                  <i className="ri-fire-line text-xs"></i>热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}